/**
 * Shared block-id validation used by both the new-block editor and the fork modal.
 */

import type { HintDescriptor } from './symbol-config'

export const BLOCK_ID_PATTERN = /^[a-zA-Z][a-zA-Z0-9_-]*$/

export type BlockIdValidation = { ok: true } | { ok: false; error: HintDescriptor }

/**
 * Validates a block id against the pattern and the list of existing ids.
 *
 * Returns `{ ok: true }` when valid and unique, or `{ ok: false, error }` where
 * `error` is a translatable {key, params} descriptor. This module is pure — it
 * can't call `t()` — so the VIEW renders it with `t(error.key, error.params)`.
 */
export function validateBlockId(id: string, existingIds: string[]): BlockIdValidation {
  if (!BLOCK_ID_PATTERN.test(id)) {
    return { ok: false, error: { key: 'blockId.error.pattern' } }
  }
  if (existingIds.includes(id)) {
    return { ok: false, error: { key: 'blockId.error.duplicate', params: { id } } }
  }
  return { ok: true }
}
